"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Renderer =
/*#__PURE__*/
function () {
  function Renderer(pathname, component, params, prevRenderer) {
    _classCallCheck(this, Renderer);

    this.data = {};
    this.component = component;
    this.params = params;
    this.pathname = pathname;
    this.prevRenderer = prevRenderer;
  }

  _createClass(Renderer, [{
    key: "getPathname",
    value: function getPathname() {
      return this.pathname;
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "getParams",
    value: function getParams() {
      return this.params;
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return {
        pathname: this.pathname,
        params: this.params
      };
    }
  }, {
    key: "getComponentProps",
    value: function getComponentProps() {
      return Object.assign(this.data, this.getProps());
    }
  }, {
    key: "getPrevProps",
    value: function getPrevProps() {
      return !!this.prevRenderer ? this.prevRenderer.getProps() : {};
    }
  }, {
    key: "getPrevComponentProps",
    value: function getPrevComponentProps() {
      if (!!this.prevRenderer) {
        return this.prevRenderer.getComponentProps();
      }

      return {};
    }
  }, {
    key: "fireInitialPropsWillGet",
    value: function fireInitialPropsWillGet() {
      if (this.isFunction(this.component.initialPropsWillGet)) {
        this.component.initialPropsWillGet(this.getProps(), this.getPrevProps());
      }

      return this;
    }
  }, {
    key: "fireGetInitialProps",
    value: function fireGetInitialProps() {
      var _this = this;

      if (!this.isFunction(this.component.getInitialProps)) {
        this.data = {};
        return Promise.resolve(this);
      }

      return Promise.resolve(this.component.getInitialProps(this.getProps(), this.getPrevProps())).then(function (params) {
        if (!!params) {
          _this.data = params;
          return _this;
        }

        _this.data = {};
        return _this;
      });
    }
  }, {
    key: "getInitialProps",
    value: function getInitialProps() {
      return this.data;
    }
  }, {
    key: "fireInitialPropsDidGet",
    value: function fireInitialPropsDidGet() {
      if (this.isFunction(this.component.initialPropsDidGet)) {
        this.component.initialPropsDidGet(this.getComponentProps(), this.getPrevComponentProps());
      }

      return this;
    }
  }, {
    key: "isFunction",
    value: function isFunction(func) {
      if (!!func && typeof func === "function") return true;
      return false;
    }
  }, {
    key: "setInitialProps",
    value: function setInitialProps(data) {
      if (!data) {
        this.data = {};
        return this;
      }

      this.data = data;
      return this;
    }
  }]);

  return Renderer;
}();

exports.default = Renderer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/Renderer.js
// module id = 133
// module chunks = 0